import identity from "lodash/identity"
import { Field } from "react-final-form"

import {
  composeValidators,
  mustNotContainNumbers,
  required,
} from "@trueskin-web/functions"
import { useTranslation } from "@trueskin-web/translations"

import InputControl from "./input-control"

const City = ({ fieldName, className }) => {
  const { t } = useTranslation()

  return (
    <Field
      data-testid="web-portal-shipping-form-city"
      name={fieldName}
      component={InputControl}
      required
      validate={composeValidators(
        (value) => required(value, t("Generic.errors.cityRequired")),
        mustNotContainNumbers
      )}
      parse={identity}
      label={t("Start.Questionnaire.city")}
      placeholder={t("Start.Questionnaire.city")}
      className={className}
    />
  )
}

export default City
